import {Box, Stack, Typography} from '@mui/material';
import * as React from 'react';
import {useEffect} from 'react';
import {useSubscription} from './hook/useSubscription';
import './subscription.css';
import SubscriptionChoiceItem from './subscriptionChoiceItem';
import axios from '../../axios';
import {useDarkMode} from '../darkMode/hook/useDarkMode';

const SubscriptionChoice = ({setShowNav}) => {
  const {subscriptionList} = useSubscription();
  useEffect(() => {
    setShowNav(true);
  }, []);

  const {mode} = useDarkMode();

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={2}>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        sx={{
          backgroundColor: mode.settings.cardBackgroundColor,
          width: '100%',
          paddingBottom: '50px !important',
        }}>
        <Typography
          variant={'subtitle12'}
          sx={{
            textAlign: 'justify',
            color: '#C72B5C',
            marginTop: '50px !important',
            marginBottom: '30px !important',
            paddingLeft: {xs: '10%', md: '20%', lg: '20%'},
            paddingRight: {xs: '10%', md: '20%', lg: '20%'},
          }}>
          Abonnez-vous à OHS Solutions
        </Typography>
        <Typography
          variant={'subtitle3'}
          sx={{
            color: mode.settings.textColor3,
            textAlign: 'left',
            paddingLeft: {xs: '10%', md: '20%', lg: '20%'},
            paddingRight: {xs: '10%', md: '20%', lg: '20%'},
          }}>
          L'abonnement à la plateforme OHS Solutions vous permet d'accéder aux
          conseils des professionnels de l'OHS de Lorraine et à des services
          pour le maintien à domicile (coût en supplément en fonction des
          services).
        </Typography>
        <br />
        {subscriptionList &&
          subscriptionList.map(subscription => (
            <SubscriptionChoiceItem
              type={subscription.name.text}
              price={subscription.price.value}
              unity={
                subscription.type === 'month'
                  ? 'mois'
                  : subscription.type === 'year'
                  ? 'an'
                  : subscription.type
              }
              required={false}
              id={subscription.id}
            />
          ))}
      </Stack>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="left"
        spacing={4}
        sx={{width: '100%'}}>
        <Typography
          variant={'subtitle13'}
          sx={{
            color: '#C72B5C',
            marginTop: '50px !important',
            paddingLeft: {xs: '10%', md: '20%', lg: '20%'},
            paddingRight: {xs: '10%', md: '20%', lg: '20%'},
          }}>
          L'abonnement mensuel
        </Typography>
        <Typography
          variant={'subtitle3'}
          sx={{
            color: mode.settings.textColor3,
            textAlign: 'left',
            paddingLeft: {xs: '10%', md: '20%', lg: '20%'},
            paddingRight: {xs: '10%', md: '20%', lg: '20%'},
          }}>
          La souscription à l'Abonnement mensuel vous abonne à OHS Solutions.
          Par l'acceptation de cette offre, vous acceptez un prélèvement mensuel
          d'un montant de 5 € sur votre compte via votre carte bleue. Ainsi,
          tant que perdure l'abonnement vous serez prélevé de la somme définie
          automatiquement chaque mois.
        </Typography>
        <Typography
          variant={'subtitle3'}
          sx={{
            color: mode.settings.textColor3,
            textAlign: 'left',
            paddingLeft: {xs: '10%', md: '20%', lg: '20%'},
            paddingRight: {xs: '10%', md: '20%', lg: '20%'},
          }}>
          Vous pourrez mettre un terme à votre Abonnement mensuel à tout moment.
          Votre abonnement sera résilié à la fin du mois en cours. Vous pourrez
          réactiver votre compte à tout moment en choisissant l'abonnement que
          vous souhaitez.
        </Typography>
        <Typography
          variant={'subtitle3'}
          sx={{
            color: mode.settings.textColor3,
            textAlign: 'left',
            paddingLeft: {xs: '10%', md: '20%', lg: '20%'},
            paddingRight: {xs: '10%', md: '20%', lg: '20%'},
          }}>
          Le premier mois de votre abonnement vous sera offert.
        </Typography>
      </Stack>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="left"
        spacing={4}
        sx={{
          backgroundColor: mode.settings.cardBackgroundColor,
          width: '100%',
        }}>
        <Typography
          variant={'subtitle13'}
          sx={{
            color: '#C72B5C',
            marginTop: '50px !important',
            paddingLeft: {xs: '10%', md: '20%', lg: '20%'},
            paddingRight: {xs: '10%', md: '20%', lg: '20%'},
          }}>
          L'abonnement annuel
        </Typography>
        <Typography
          variant={'subtitle3'}
          sx={{
            color: mode.settings.textColor3,
            textAlign: 'justify',
            paddingLeft: {xs: '10%', md: '20%', lg: '20%'},
            paddingRight: {xs: '10%', md: '20%', lg: '20%'},
          }}>
          La souscription à l'abonnement annuel vous permet de vous abonner pour
          une période de un an. Le paiement de cet abonnement sera effectué en
          une seule fois, lors de la souscription. L’engagement est ferme sur la
          période.
        </Typography>
        <Typography
          variant={'subtitle3'}
          sx={{
            color: mode.settings.textColor3,
            textAlign: 'justify',
            paddingLeft: {xs: '10%', md: '20%', lg: '20%'},
            paddingRight: {xs: '10%', md: '20%', lg: '20%'},
            marginBottom: '50px !important',
          }}>
          Lors de l’arrivée de l’échéance de l’abonnement d’un an, aucune
          reconduction tacite de l’abonnement ne sera effectuée. Vous pourrez
          réactiver votre compte à tout moment en choisissant l'abonnement que
          vous souhaitez.
        </Typography>
      </Stack>
      <Stack
        direction="column"
        alignItems={'center'}
        gap={8}
        sx={{width: '100%'}}>
        <Stack
          alignItems={'center'}
          justifyContent={'center'}
          direction={'row'}
          width={{xs: '90%', md: '90%', lg: '90%'}}
          flexWrap={'wrap'}>
          <Stack
            sx={{
              marginTop: '64px',
              marginBottom: '50px !important',
              justifyContent: 'space-around',
            }}
            direction={'column'}
            spacing={4}>
            <Typography
              variant={'subtitle13'}
              sx={{color: '#C72B5C', textAlign: 'center'}}>
              Un abonnement, six comptes
            </Typography>
            <Box
              sx={{
                padding: '20px',
                width: {xs: '340px', md: '400px', lg: '525px'},
                height: {xs: '140px', md: '230px', lg: '230px'},
                backgroundImage: `url(${axios.defaults.frontURL}/assets/img/1_abonnement_5_comptes.png)`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}></Box>
          </Stack>
          <Stack
            direction={'column'}
            width={{xs: '90%', md: '100%', lg: '45%'}}>
            <Typography
              variant={'subtitle3'}
              sx={{
                color: mode.settings.textColor3,
                textAlign: 'justify',
                paddingRight: '20%',
              }}>
              Sur votre compte, vous pourrez ajouter gratuitement 5 autres
              personnes. Vous aurez alors le choix entre deux profils :
            </Typography>
            <ul>
              <li>
                <Typography
                  variant={'subtitle3'}
                  sx={{
                    color: mode.settings.textColor3,
                    textAlign: 'justify',
                    paddingRight: '20%',
                  }}>
                  Le profil entourage : pour communiquer et échanger avec vous.
                </Typography>
              </li>
              <li>
                <Typography
                  variant={'subtitle3'}
                  sx={{
                    color: mode.settings.textColor3,
                    textAlign: 'left',
                    paddingRight: '20%',
                  }}>
                  Le profil Parrain digital : pour vous aider à utiliser votre
                  compte.
                </Typography>
              </li>
            </ul>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default SubscriptionChoice;
